import apiClient from '@/apis/client';
import { Plan } from '@/types/plan';

export interface ResponseGetPlan {
  data: Plan[];
  total: number;
}

export default async function getPlansApi(): Promise<ResponseGetPlan> {
  return apiClient.get<ResponseGetPlan>('/plan');
}
